import { FundriseRouteConfig } from 'vue-router';

const fundLandingPageRoutes: FundriseRouteConfig[] = [
	{
		path: '/campaigns/fund/flagship',
		name: 'fund-flagship',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		component: () => import('@views/marketing-site/fund/flagship-fund.vue')
	},
	{
		path: '/campaigns/fund/income',
		name: 'fund-income',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		component: () => import('@views/marketing-site/fund/income-fund.vue')
	},
	{
		path: '/campaigns/fund/innovation',
		redirect: { name: 'vcx-landing' },
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' }
	},
	{
		path: '/incomefund',
		redirect: { name: 'fund-income' },
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' }
	}
];

export default fundLandingPageRoutes;
